<template>
  <div :class="$style.container">
    <span
      v-m-r="4"
      v-text="displayMonth"
    ></span>
    <span
      v-text="displayYear"
    ></span>
  </div>
</template>

<script>
import { MONTHS_OF_YEAR_LIST } from 'definitions/datepicker';

export default {
  name: 'MonthOfYear',
  props: {
    month: {
      type: Object,
      required: true,
    },
  },
  computed: {
    displayMonth() {
      const formattedMonthName = Number(this.month.format('M')) - 1;

      return this.$t(MONTHS_OF_YEAR_LIST[formattedMonthName]);
    },
    displayYear() {
      return this.month.format('YYYY');
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +font-type('regular', 14, 18)
    text-align: left
</style>
